<template>
  <a href="https://ae.exchange">
    <div id="logo_group">
      <div id="logo_ae-png2" :style="{ background: 'url('+store.serverConf[store.currentServer].path+'/images/ae-png2.png)' }"></div>

      <div id="logo_line32"></div>
      <div id="logo_al-ex">
        Alternative
        Exchange
      </div>
      <div class="lk-banner-type">
        <div class="lk-banner-type-left" :style="{backgroundColor: store.serverConf[store.currentServer].color} "></div>
        <div class="lk-banner-type-text" style="text-align: center">{{store.serverConf[store.currentServer].name}}</div>
        <div class="lk-banner-type-right" :style="{backgroundColor: store.serverConf[store.currentServer].color} "></div>
      </div>

    </div>

  </a>
</template>
<script>

import {useMyStorage} from "@/store/global"

export default {
  name:"LogoComponent",
  setup() {
    const store = useMyStorage();
    return {
      store
    }
  }
}
</script>
<style>
.lk-banner-type {
  width: 77px;
  height: 32px;
  position: absolute;
  left: 170px;
  top: 7px;
  overflow: hidden;
}

.lk-banner-type-left {
  /*background-color: #26c39e;*/
  /*background-color: #e82862;*/
  width: 50px;
  height: 30px;
  position: absolute;
  left: 44px;
  top: 0;
  -webkit-transform-origin-x: 0;
  -webkit-transform-origin-y: 0;
  -moz-transform-origin: 0 0;
  -o-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  transform: rotate(110.32deg);
  -moz-transform: rotate(110.32deg);
  -ms-transform: rotate(110.32deg);
  -webkit-transform: rotate(110.32deg);
  -o-transform: rotate(110.32deg);
}

.lk-banner-type-text {
  color: white;
  position: absolute;
  left: 2px;
  top: 14px;
  width: 65px;
  z-index: 100;
}

.lk-banner-type-right {
  /*background-color: #26c39e;*/
  /*background-color: #e82862;*/
  width: 50px;
  height: 30px;
  left: 74px;
  top: 0;
  position: absolute;
  -webkit-transform-origin-x: 0;
  -webkit-transform-origin-y: 0;
  -moz-transform-origin: 0 0;
  -o-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  transform: rotate(110.32deg);
  -moz-transform: rotate(110.32deg);
  -ms-transform: rotate(110.32deg);
  -webkit-transform: rotate(110.32deg);
  -o-transform: rotate(110.32deg);
}

#logo_group {
  position: relative;
  width: 171.71px;
  float: left;
}

/* Alternative Exchange */
#logo_al-ex {
  position: absolute;
  left: 74.29px;
  top: 9px;
  width: 97.43px;
  height: 31px;

  font-family: Bahnschrift;
  font-style: normal;
  /* font-weight: 300;*/
  font-size: 15.5px;
  line-height: 16px;
  /* or 100% */
  text-transform: uppercase;

  color: #333333;
}

/* Line 32 */
#logo_line32 {
  position: absolute;
  left: 66.54px;
  top: 8.11px;
  width: 31.88px;
  border: 1px solid #d4d9dd;
  -webkit-transform-origin-x: 0;
  -webkit-transform-origin-y: 0;
  -moz-transform-origin: 0 0;
  -o-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  transform: rotate(110.32deg);
  -moz-transform: rotate(110.32deg);
  -ms-transform: rotate(110.32deg);
  -webkit-transform: rotate(110.32deg);
  -o-transform: rotate(110.32deg);
}

/* ae-png 2 */
#logo_ae-png2 {
  position: absolute;
  left: 0;
  top: 7px;
  width: 47px;
  height: 31px;
  background-size: 47px 31px;
  /*background: url('/lk/images/ae-png2.png');*/
}
</style>
